import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IDeliveredShort } from "../models/dsException";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 */

export const GetPartialRefusalAPI = async (
  osdNumber: number | string,
): Promise<IDeliveredShort> => {
    try {
      const url = `${getUrl(ApiType.REFUSAL_ENTRY_DETAILS)}/${osdNumber}`;
      const response = await axios.get(url);
      return response?.data ?? {};
    } catch (error) {
      return throwApiError(error, ErrorMessages.prEntryDetailsAPIError, { badRequestOrder: "errorsFirst" });
    }
};
